export const bytesInGB = 1000000000;
export const kilobytes = 1000;
export const freeStorage = bytesInGB * 100;
